export enum WorkInstanceType {
    Regular = 0,
    Conceptual = 10,
}